module.exports = __webpack_public_path__ + "static/media/font_regular.db20e116.woff";